import { Link, useOutletContext } from "react-router-dom";
import { Wand2, Package, AlertTriangle, Wallet } from "lucide-react";
import { useApi } from "@/lib/useApi";
import { fcfa, ORDER_STATUS } from "@/lib/api";
import { Loading } from "@/components/RequireAuth";
import { Button } from "@/components/ui/button";

const Stat = ({ icon: I, label, value, testid }) => (
  <div className="rounded-xl border bg-white p-4">
    <I className="h-5 w-5 text-orange-500" />
    <p data-testid={testid} className="tnum mt-2 font-display text-2xl font-black">{value}</p>
    <p className="text-xs text-gray-500">{label}</p>
  </div>
);

export default function SellerOverview() {
  const { data } = useApi("/seller/stats");
  const { shop } = useOutletContext();
  if (!data) return <Loading />;
  return (
    <div data-testid="seller-overview" className="space-y-6">
      <h1 className="font-display text-3xl font-black tracking-tight">Tableau de bord</h1>
      <div className="ai-glow rounded-2xl">
        <div className="flex flex-col gap-4 rounded-2xl bg-white p-6 md:flex-row md:items-center">
          <span className="grid h-12 w-12 place-items-center rounded-xl bg-indigo-500 text-white"><Wand2 className="h-6 w-6" /></span>
          <div className="flex-1"><p className="font-display text-xl font-bold">Créez une fiche produit en moins de 4 minutes</p><p className="text-sm text-gray-500">Ajoutez une photo ou un lien : l'IA prépare le brouillon, vous vérifiez et publiez.</p></div>
          <Button asChild className="rounded-full bg-indigo-600 hover:bg-indigo-700" data-testid="overview-ai-cta"><Link to="/vendeur/ia">Commencer</Link></Button>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <Stat icon={Package} label="Produits (publiés)" value={`${data.products} (${data.published})`} testid="stat-products" />
        <Stat icon={AlertTriangle} label="Stock faible (≤ 3)" value={data.low_stock} testid="stat-low-stock" />
        <Stat icon={Wallet} label="Ventes (hors annulées)" value={fcfa(data.revenue, shop.currency)} testid="stat-revenue" />
        <Stat icon={Package} label="Nouvelles commandes" value={data.orders.recue} testid="stat-new-orders" />
      </div>
      <div className="rounded-xl border bg-white p-5">
        <p className="mb-3 font-display text-lg font-bold">Commandes par statut</p>
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-4">
          {Object.entries(data.orders).map(([s, n]) => <div key={s} className="rounded-lg bg-gray-50 p-3"><p className="tnum font-display text-xl font-black">{n}</p><p className="text-xs text-gray-500">{ORDER_STATUS[s]}</p></div>)}
        </div>
      </div>
    </div>
  );
}
